import { combineReducers } from 'redux';

// reducer import
import customizationReducer from './customizationReducer';
import questionsReducer from './Questions/reducer';
import announcementsReducer from './Announcements/reducer';
import responseReducer from './ResponseTemplate/reducer';
import historyReducer from './History/reducer';
import authReducer from './Authentication/reducer';
import myTeamReducer from './MyTeam/reducer';
import calendarReducer from './Calendar/reducer';
import notificationReducer from './Notification/reducer';
import executiveTeamReducer from './ExecutiveTeam/reducer';
import questionPromptReducer from './MonthlyPrompt/reducer';
import DashboardReducer from './Dashboard/reducers';
import { CLEAR_DATA } from './actions';
import EngagementReducer from './EngagementLevel/reducer';
// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    customization: customizationReducer,
    question: questionsReducer,
    announcements: announcementsReducer,
    history: historyReducer,
    authentication: authReducer,
    myteam: myTeamReducer,
    response: responseReducer,
    calendar: calendarReducer,
    notification: notificationReducer,
    executiveTeam: executiveTeamReducer,
    questionPrompt: questionPromptReducer,
    dashboard: DashboardReducer,
    engagement: EngagementReducer
});
const rootReducer = (state, action) => {
    if (action.type === CLEAR_DATA) {
        return reducer(undefined, action);
    }
    return reducer(state, action);
};

export default rootReducer;
